import createSeededRng from 'seedrandom'

const colorNames = [
  'red',
  'orange',
  'amber',
  'yellow',
  'lime',
  'green',
  'emerald',
  'teal',
  'cyan',
  'sky',
  'blue',
  'indigo',
  'violet',
  'purple',
  'fuchsia',
  'pink',
  'rose',
  'slate',
  'gray',
  'zinc',
  'neutral',
  'stone',
]

export const getUserAvatarFallbackBg = (userId: number) => {
  const random = createSeededRng(userId.toString())
  const colorIndex = Math.floor(random() * colorNames.length)
  const colorName = colorNames[colorIndex]

  return `linear-gradient(135deg, var(--color-${colorName}-500), var(--color-${colorName}-600))`
}
